module.exports = __webpack_public_path__ + "img/Elven_Staff_01.a795ce23.png";